import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

const alignmentStyles: Record<string, string> = {
  left: 'margin:0 auto 0 0',
  center: 'margin:0 auto',
  right: 'margin:0 0 0 auto',
}

function normaliseWidth (value: unknown): string {
  if (typeof value !== 'string' || !value) return '100%'
  return /^\d+$/.test(value) ? `${value}px` : value
}

export const EmailImage = Image.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      width: {
        default: '100%',
        parseHTML: element => normaliseWidth(element.style.width || element.getAttribute('width')),
      },
      alignment: {
        default: 'center',
        parseHTML: element => element.getAttribute('data-alignment') || 'center',
      },
    }
  },

  renderHTML ({ HTMLAttributes }) {
    const {
      alignment = 'center',
      width = '100%',
      ...attributes
    } = HTMLAttributes
    const style = [
      'display:block',
      `width:${normaliseWidth(width)}`,
      'max-width:100%',
      'height:auto',
      alignmentStyles[alignment] ?? alignmentStyles.center,
    ].join(';')

    return ['img', mergeAttributes(this.options.HTMLAttributes, attributes, {
      'data-alignment': alignment,
      style,
    })]
  },
})
